import { Card, Form, Radio, Space } from 'antd';
import { RETURN_METHOD } from 'constants/ordersReturn';
import { useTranslation } from 'react-i18next';

export default function ReturnMethod() {
  const { t } = useTranslation();
  return (
    <Card title={t('ordersReturn.returnMethod')}>
      <Form.Item
        name="returnMethod"
        rules={[
          {
            required: true,
            message: t('orders.paymentGroupMethod.validateMsg.required'),
          },
        ]}
        initialValue={Object.values(RETURN_METHOD)?.[0]?.value}
      >
        <Radio.Group defaultValue={Object.values(RETURN_METHOD)?.[0]?.value}>
          <Space direction="vertical" size={15}>
            {Object.values(RETURN_METHOD)?.map((item) => (
              <Radio key={item.value} value={item.value}>
                {t(item?.text)}
              </Radio>
            ))}
          </Space>
          {/* <Radio
            key={Object.values(RETURN_METHOD)?.[0].value}
            value={Object.values(RETURN_METHOD)?.[0].value}
          >
            {t(Object.values(RETURN_METHOD)?.[0]?.text)}
          </Radio> */}
        </Radio.Group>
      </Form.Item>
    </Card>
  );
}
